import React from 'react';
import './agentPayoutApprovalDetails.scss';
import { formatDate2 } from '../../utils/dateFormat';
import { AgentStatus } from '../../utils/types';

type AgentPayoutApprovalDetailsProps = {
    approvalsData: AgentStatus;
};

export const AgentPayoutApprovalDetails = ({approvalsData}: AgentPayoutApprovalDetailsProps) => {
    function renderLabelValue(label: string, value: string | null|undefined) {
        return (
          <div className="col-md-2 border-end">
            <div className="row">
              <div className="col-md-12">
                <strong>{label}</strong>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-12">
                {value!== undefined && value !== null ? value : 'N/A'}
              </div>
            </div>
          </div>
        );
      }
    return (
        <div className="card mt-3 border-0">
            <div className="card-header border-0" style={{ backgroundColor: '#ebf2f9', padding: '15px' }}>
                Payout Approval Details
            </div>
            <div className="card-body tableContentCardBody">
      <div className="row">
        {[
          { label: 'Agent Status', value: approvalsData.agent_status },
          { label: 'TL Name', value: approvalsData.tl_name },
          { label: 'TL Status', value: approvalsData.tl_status },
          {
            label: 'TL Approval Date',
            value:
              approvalsData.tl_approval_date != null
                ? formatDate2(approvalsData.tl_approval_date.toString())
                : null,
          },
          { label: 'Manager Name', value: approvalsData.manager_name },
          { label: 'Manager Status', value: approvalsData.manager_status },
          {
            label: 'Manager Approval Date',
            value:
              approvalsData.manager_approval_date != null
                ? formatDate2(approvalsData.manager_approval_date.toString())
                : null,
          },
          { label: 'Comp Export', value: approvalsData.comp_export },
          {
            label: 'Extract Date',
            value:
              approvalsData.extract_date != null
                ? formatDate2(approvalsData.extract_date.toString())
                : null,
          },
          { label: 'Scorecard', value: approvalsData.scorecard_name },
          { label: 'Project', value: approvalsData.project_name },
          { label: 'Country', value: approvalsData.country_name },
          { label: 'Site', value: approvalsData.site_name },
        ].map((item, index) => (
          <React.Fragment key={index}>
            {renderLabelValue(item.label, item.value)}
          </React.Fragment>
        ))}
      </div>
    </div>
        </div>
    );
};
